import { FullPattern } from '../core-data-model/Pattern.model';

export class BehavioralPatternConfig {
    personName: string;
    referencePatternNumber: number;
    pattern: FullPattern;
    completedDate?: Date;
}
